// prettier-ignore
import { updateModal } from 'app/App.components/Modal/Modal.actions'
import * as React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { State } from 'reducers'
import { BidView } from './Bid.view'

interface BidProps {
  owner: string
  collection: string
  item: any
}

export const Bid = ({ owner, collection, item }: BidProps) => {
  const dispatch = useDispatch()

  const version = useSelector((state: State) => state.version.number)
  const wallet = useSelector((state: State) => state.wallet)

  const updateModalCb = (title: string, children: JSX.Element) => {
    dispatch(updateModal(title, children))
  }
  return (
    <BidView
      version={version}
      owner={owner}
      collection={collection}
      wallet={wallet}
      updateModal={updateModalCb}
      item={item}
    />
  )
}
